import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import ButtonBase from "../../../../common/components/form/ButtonBase.jsx";
import ButtonIconTrash from "../../../../common/components/form/ButtonIconTrash.jsx";
import * as API from "../../../lib/api.js";
import PaymentMethodChosing from "../../Payment/PaymentMethodChoosing.jsx";

const CAMPAIGN_STATUS = {
    0: "UNSPECIFIED",
    1: "UNKNOWN",
    2: "ACTIVE",
    3: "PAUSED",
    4: "REMOVED",
};

export default function WebsiteMarketingAd(props) {
    const [modalOpen, setModalOpen] = React.useState(false);
    const domFormWrap = React.useRef();

    const { t } = useTranslation();
    const { id } = useParams();

    const { campaign, campaign_google_ads } = props;
    const { ad_group, keywords, metrics } = campaign;
    const { payed, description } = campaign_google_ads;
    const { period } = JSON.parse(description);

    if (!campaign) {
        return <h3 className="panel-heading-text">{t("WebsiteMarketingNoCampaigns")}</h3>;
    }

    const canDelete = [3].includes(campaign?.campaign.status);
    const canStart = [3].includes(campaign?.campaign.status);

    function getPayment(system) {
        API.GooglePayment(system, { id_project: id, campaign_id: campaign.campaign.id })
            .then(({ html }) => {
                domFormWrap.current.innerHTML = html;
                let form = domFormWrap.current.querySelector("form");
                form && form.submit();
            })
            .catch(e => console.warn("[Error at PaymentOverlay]", e));
    }

    function onDeleteClick() {
        props?.setLoading?.(true);
        API.GoogleAdsDel(id, campaign.campaign.id)
            .then(response => {
                response; // TODO

                props?.setLoading?.(false);
                props.onUpdate();
            })
            .catch(e => {
                props?.setLoading?.(false);
            });
    }

    function onCancel() {
        setModalOpen(false);
    }

    return (
        <>
            <div ref={domFormWrap} style={{ display: "none" }}></div>

            <div
                className="website-marketing-list"
                key={campaign?.campaign.id}
                style={{ filter: campaign?.campaign.status === 4 ? "opacity(0.5) blur(0.1px)" : "" }}
            >
                <div className="website-marketing-item">
                    <div className="grid-gap-20" style={{ gridTemplateColumns: "1fr max-content" }}>
                        <div>
                            <h3 className="website-marketing-item-title">{campaign?.campaign.name}</h3>
                            <h3>{ad_group?.name}</h3>
                        </div>

                        <div>{canDelete && <ButtonIconTrash onClick={onDeleteClick} disabled={!canDelete} />}</div>
                    </div>

                    <div className="website-marketing-item-stats">
                        <div>
                            <p>Campaign Status:</p>

                            <p
                                style={{
                                    textAlign: "center",
                                    fontSize: "larger",
                                    textDecoration: "underline",
                                    fontWeight: "600",
                                }}
                            >
                                {CAMPAIGN_STATUS[campaign?.campaign.status]}
                            </p>
                        </div>

                        <div>
                            <p>{`Campaign Clicks: ${metrics.clicks}`}</p>
                            <p>{`Campaign Conversion: ${metrics?.conversions}`}</p>
                            <p>{`Campaign Cost Micros: ${metrics?.cost_micros}`}</p>
                            <p>{`Campaign Impression: ${metrics?.impressions}`}</p>
                        </div>

                        <div>
                            <p>{`Campaign Period: ${period}`}</p>
                            <p>{`Campaign End-Date: ${metrics?.conversions}`}</p>
                        </div>
                    </div>

                    <div className="website-marketing-item-stats">
                        <h3>Keywords:</h3>

                        <div className="website-marketing-item-stats-keywords">
                            {keywords?.map((keyword, index) => {
                                return <p key={index}>{keyword.text}</p>;
                            })}
                        </div>
                    </div>

                    {!payed && canStart && (
                        <>
                            <ButtonBase onClick={() => setModalOpen(true)} w100 red>
                                {t("WebsiteMarketingNeedToPay").toUpperCase()}
                            </ButtonBase>

                            {/* <div className="website-marketing-item-payment-status" onClick={() => setModalOpen(true)}>
                                {t("WebsiteMarketingNeedToPay").toUpperCase()}
                            </div> */}
                        </>
                    )}

                    <PaymentMethodChosing
                        show={modalOpen}
                        header={t("PaymentMethodChoosing")}
                        text={t("PaymentMethodChoosingText")}
                        actions={[
                            {
                                onClick: () => getPayment("paypal"),
                                text: t("PayPal"),
                                props: { invert: true },
                            },
                            {
                                onClick: () => getPayment("liqpay"),
                                text: t("LiqPay"),
                                props: { invert: true },
                            },
                            { onClick: onCancel, text: t("Cancel") },
                        ]}
                    />
                </div>
            </div>
        </>
    );
}
